<template>
    <router-link
        :to="{name: 'portal.news.single', params: {slug: news.slug}}"
        class="news-card">
        <article>
            <figure class="news-card__figure">
                <picture>
                    <img
                        loading="lazy"
                        :src="thumbnail"
                        :alt="news.slug"
                        :title="news.title">
                </picture>
            </figure>
            <div class="news-card__content">
                <div>
                    <h2 class="title">{{ news.title }}</h2>
                    <div class="subtitle">{{ news.subtitle }}</div>
                </div>
                <time class="time" :datetime="timeSI" pubdate>
                    <span class="far fa-clock" />
                    {{ timeText }}
                </time>
            </div>
        </article>
    </router-link>
</template>
<script>
import mixin from '../../mixin';
import NoImageIcon from '@images/no-image.jpg';

export default {
    mixins: [mixin],
    props: {
        news: {
            required: true,
            type: Object
        }
    },
    computed: {
        timeText: function() {
            return moment(this.news.published_at).format('DD/MM/YYYY')
        },
        timeSI: function() {
            return moment(this.news.published_at).format('YYYY-MM-DD hh:mm')
        },
        thumbnail: function() {
            return this.news.thumbnail ? this.news.thumbnail : NoImageIcon;
        }
    }
}
</script>
